import {Vector3} from "three";

export interface Camera {
    id:                      string;
    type:                    Type;
    floorVerticalPosition: string;
    title:                   string;
    description:             string;
    floorLevel:              number;
    position:                string;
    rotation:                string;
    uposition:               string;
    urotation:               string;
    hasQA:                   boolean;
    fieldOfView:             number;
}

export enum Type {
    Feature = "feature",
    Waypoint = "waypoint",
}

export interface ApiSiteModel {
    explorerType: string;
    stageId:      string;
    stageUrl:     string;
    explorerUrl:  string;
    config:       Config;
    views:        Record<string, View>; //{ [key: string]: View };
}

export interface Config {
    defaultArchetypeId: string;
    archetypes:         Archetype[];
    has360:             boolean;
    version:            number;
}

export interface Archetype {
    archetypeID: string;
    description: string;
    title:       string;
}

export interface View {
    archetypeId: string;
    apartment: Apartment;
    thumbs:    Thumbs;
    minimap:   Minimap;
}

export interface Apartment {
    hasHDR:      boolean;
    version:     number;
    id:          string;
    name:        string;
    type:        string;
    dayOfYear:   number;
    timeInHours: number;
    offsetUTC:   number;
    latitude:    number;
    longitude:   number;
    minimaps:    string[];
    cameras:     Camera[];
    hasLores:    boolean;
    thumbs:      Thumbs;
}

export interface Minimap {
    storeys: Storey[];
}

export interface Storey {
    position:              Vector3;
    rotation:              Vector3;
    fovY:                  number;
    sunsimFiles:           string[];
    sunsimFilesTimeStamps: string[];
    defaultSunsimFile:     string;
}

export interface Thumbs {
    cameras: ThumbsCamera[];
}

export interface ThumbsCamera {
    v:           string;
    id:          string;
    title:       string;
    description: string;
}

export enum LayerType {
    Default = 0,
    Markers = 1,
    NoDepth = 2,
}
